import colors from './colors';
import images from './images';

/** 经典金 — 当前收银台默认主题 */
export default {
  id: 'classic-gold',
  name: 'Classic Gold',

  colors,

  gradients: {
    btnPrimary: `linear-gradient(180deg, ${colors.btnGradientStart} 0%, ${colors.btnGradientEnd} 100%)`,
    btnStrong: `linear-gradient(180deg, ${colors.btnStrongGradientStart} 0%, ${colors.btnStrongGradientEnd} 100%, ${colors.btnStrongGradientEnd2} 100%)`,
  },

  images,
};
